import { IClassname } from '@/lib/shared/model/classname';

export const InfraAccess = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_676)">
        <path
          d="M15.361 19.2043V18.5654C15.361 16.8707 14.6877 15.2455 13.4894 14.0473C12.2912 12.849 10.666 12.1758 8.97137 12.1758C7.27675 12.1758 5.65153 12.849 4.45326 14.0473C3.25497 15.2455 2.58179 16.8707 2.58179 18.5654V19.2043"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4442 5.14746C13.4589 5.3602 13.4589 5.57368 13.4442 5.78642C13.4442 6.97266 12.9729 8.11031 12.1342 8.9491C11.2954 9.7879 10.1577 10.2591 8.97146 10.2591C7.78524 10.2591 6.64758 9.7879 5.80878 8.9491C4.96999 8.11031 4.49875 6.97266 4.49875 5.78642C4.49875 5.61007 4.47959 5.31742 4.49875 5.14746"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.0571 19.2041H1.94291C1.59003 19.2041 1.30396 19.4902 1.30396 19.8431V30.0664C1.30396 30.4192 1.59003 30.7054 1.94291 30.7054H30.0571C30.4099 30.7054 30.696 30.4192 30.696 30.0664V19.8431C30.696 19.4902 30.4099 19.2041 30.0571 19.2041Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4727 19.2048C20.4727 18.1881 20.8766 17.213 21.5956 16.494C22.3145 15.775 23.2897 15.3711 24.3064 15.3711C25.3231 15.3711 26.2983 15.775 27.0173 16.494C27.7362 17.213 28.1402 18.1881 28.1402 19.2048H20.4727Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4442 5.14723C10.5233 4.29486 7.41968 4.29486 4.49878 5.14723V2.59139C4.49878 2.25246 4.63342 1.92743 4.87307 1.68777C5.11273 1.44811 5.43777 1.31348 5.7767 1.31348H12.1663C12.5052 1.31348 12.8302 1.44811 13.0699 1.68777C13.3096 1.92743 13.4442 2.25246 13.4442 2.59139V5.14723Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0286 12.8154H25.5844"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 12.8154V15.3713"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 28.1498V23.0381"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1948 28.1498V23.0381"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 25.5938H19.1947"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.97158 14.7317C8.79514 14.7317 8.6521 14.5887 8.6521 14.4123C8.6521 14.2358 8.79514 14.0928 8.97158 14.0928"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M8.97144 14.7317C9.14788 14.7317 9.29091 14.5887 9.29091 14.4123C9.29091 14.2358 9.14788 14.0928 8.97144 14.0928"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M8.97158 17.6067C8.79514 17.6067 8.6521 17.4637 8.6521 17.2873C8.6521 17.1108 8.79514 16.9678 8.97158 16.9678"
          stroke="#22364A"
          strokeWidth="1.33"
        />
        <path
          d="M8.97168 17.6067C9.14812 17.6067 9.29116 17.4637 9.29116 17.2873C9.29116 17.1108 9.14812 16.9678 8.97168 16.9678"
          stroke="#22364A"
          strokeWidth="1.33"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_676">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
